// extracted by mini-css-extract-plugin
module.exports = {"PositiveAmount":"RowProwider_PositiveAmount__1hXGW","NegativeAmount":"RowProwider_NegativeAmount__2KsIx","Amount":"RowProwider_Amount__3S5Fi"};